import React from 'react'
import Hero from './Hero'
import Intro from './Intro'
import Showcase from './Showcase'

const MyProjects = () => {
  return (
    <>
    <Hero/>
    <Intro/>
    <Showcase/>
    </>
  )
}

export default MyProjects